export default "__VITE_ASSET__D1v6D8qJ__"